const SESSION_AUDIT_OPERATION_KEY = 'auditedAccounts.selectedAuditOperationId';
const SESSION_BUSINESS_KEY = 'auditedAccounts.selectedBusinessId';

export function clearAuditedAccountsSessionSelection(): void {
  sessionStorage.removeItem(SESSION_AUDIT_OPERATION_KEY);
  sessionStorage.removeItem(SESSION_BUSINESS_KEY);
}

export function persistAuditedAccountsBusinessId(id: string | number): void {
  sessionStorage.setItem(SESSION_BUSINESS_KEY, String(id));
}

export function persistAuditedAccountsOperationId(id: number): void {
  sessionStorage.setItem(SESSION_AUDIT_OPERATION_KEY, String(id));
}

export function getStoredAuditedAccountsBusinessId(): number | null {
  const stored = sessionStorage.getItem(SESSION_BUSINESS_KEY);
  if (!stored) {
    return null;
  }

  const parsed = Number(stored);
  return Number.isNaN(parsed) ? null : parsed;
}

export function getStoredAuditedAccountsOperationId(): number | null {
  const stored = sessionStorage.getItem(SESSION_AUDIT_OPERATION_KEY);
  if (!stored) {
    return null;
  }

  const parsed = Number(stored);
  return Number.isNaN(parsed) ? null : parsed;
}
